// extracted by mini-css-extract-plugin
export default {"select":"_b9IkIPtPKhE3f3tSx_R__select___"};